import * as React from 'react';
import { Text, Button, Card, CardHeader, CardBody } from '@chakra-ui/react';

import { Modal, Link, RequirementsRemedy } from 'shared-components';
import { IFinance, IPersonalInfo } from '../../../../../types';

interface IProps {
  onClose: () => void;
  onContinue: () => void;
  depositInstructionLink: string;
  depositeUneditable?: boolean;
}

const AwaitingDepositModal: React.FC<IProps> = (props: IProps) => {
  return (
    <Modal
      id={'awaitingDeposit'}
      show={true}
      title={'Pay your deposit and update status'}
      onClose={props.onClose}
      hideFooter
    >
      <Text>
        In order to accept your offer at the university <b>you will need to pay a deposit</b>.
      </Text>

      <Card variant="filled" mb={4}>
        <CardHeader pb={0}>More information on how to pay your deposit:</CardHeader>

        <CardBody>
          <Link href={props.depositInstructionLink} isExternal>
            How to pay your deposit
          </Link>
        </CardBody>
      </Card>

      {!props.depositeUneditable && (
        <RequirementsRemedy title="Once you have paid your deposit">
          <Text>
            Use the button below to return to the Deposit question and <b>update your answer to “Yes”</b>.
          </Text>

          <Button onClick={props.onContinue} variant="solid" size="lg">
            Return to deposit question
          </Button>
        </RequirementsRemedy>
      )}
    </Modal>
  );
};

export default AwaitingDepositModal;
